"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormHelpers = useFormHelpers;
const react_1 = require("react");
function useFormHelpers(timeout = 3000) {
    // The exported `setIsSaved` is the wrapper below, which also schedules the
    // reset, so the raw setter cannot take that name.
    // eslint-disable-next-line react/hook-use-state -- setter is wrapped, see above
    const [isSaved, _setIsSaved] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    function setIsSaved(_isSaved) {
        _setIsSaved(_isSaved);
        if (_isSaved) {
            setTimeout(() => {
                _setIsSaved(false);
            }, timeout);
        }
    }
    function reset() {
        setError(null);
        setIsSaved(false);
        setIsLoading(false);
    }
    return {
        reset,
        setIsSaved,
        isSaved,
        error,
        isLoading,
        setIsLoading,
        setError
    };
}
